import { render } from "./OrgIntegrationsMain.vue?vue&type=template&id=8c36155c"
import script from "./OrgIntegrationsMain.vue?vue&type=script&lang=js"
export * from "./OrgIntegrationsMain.vue?vue&type=script&lang=js"

import "./OrgIntegrationsMain.vue?vue&type=style&index=0&id=8c36155c&lang=css"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__